﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { DialogService } from "@app/services/dialog.service";
import { KbService } from "@app/services/kb.service";
import { IRootScope, MediaDialogButton } from "@models";
import { icons } from "@tools";

export interface IMediaSelectScope extends ng.IScope {
    ngModel: string;

    isEnabled: () => boolean;
    clear: () => void;
    click: () => void;
}

@NgComponent({
    token: Token.KbMediaSelect,
    dependencies: [
        Token.KbService,
        Token.$RootScope,
        Token.DialogService,
    ]
})
export class KbMediaSelect extends Directive {
    constructor(
        kbService: KbService,
        $rootScope: IRootScope,
        dialogService: DialogService
    ) {
        super();
        this.replace = true;
        this.restrict = "E";
        this.scope = {
            ngModel: "="
        };
        this.template = Dirs.component("kb-media-select");

        this.link = (scope: IMediaSelectScope, element, atts, ngModelController: ng.INgModelController) => {
            scope.isEnabled = () => {
                return !($(element).hasClass("disabled") || $(element).attr("disabled"));
            };

            scope.clear = () => {
                scope.ngModel = null;
            };

            scope.click = () => {
                if (scope.isEnabled()) {
                    dialogService.mediaSelect({
                        startPath: scope.ngModel,
                        buttons: [
                            new MediaDialogButton(loc.ok, icons.success, args => {
                                scope.ngModel = args.selectedItem ? args.selectedItem.relativePath : null;
                            }),
                            new MediaDialogButton(loc.cancel, icons.cancel, args => {

                            })
                        ]
                    });
                }
            };
        };
    }
}
